<template>
    <div class="drive-uploader" ref="uploader-box">
        <UploadPanel :all="all" :cancelFile="cancelFile.bind(this)" v-show="showPanel" @close="close" :total="total" :files="files"></UploadPanel>
        <input id="upbtn" ref="btn" class="upload-input" type="button" value="hello" />
    </div>
</template>

<script>
import plupload from 'plupload'
import UploadPanel from './UploadPanel'
import UploadDropZone from './UploadDropZone'
import {saveFile,fetchUploadFileUrl} from '@/store/service/index'
import { mapState, mapActions,mapGetters, mapMutations } from 'vuex'

export default {
    name: 'uploader',
    components:{
        UploadPanel,
        UploadDropZone
    },
    data () {
        return {
            total: {
                queued: 0,
                loaded: 0,
                failed: 0,
                uploaded: 0
            },
            files: [],
            rmfiles: [],
            emptyfiles: [],
            showPanel: false,
            uploader: null,
            path: {
                groupid: 0,                         
                parentid: 0,
                filename: '', // 旧的文件名, 上传新版本用
                isNewVersion: false, // 是否上传新版本
                directory: '' // 上传文件所在的目录，设置打开目录用到
            }
        }
    },
    computed:{
        ...mapState([
            'group',
            'parentid',
            'isFolder',
            'uploadConf',
            'route',
            'dialogData'
            
        ]),
        ...mapState('index',[
            'auto'
        ]),
        ...mapGetters('index',[
            'shouldFlush'
            
        ]),
        all(){
            return this.total.uploaded + this.total.queued + this.rmfiles.length + this.total.failed
        }
    },
    methods: {
        ...mapMutations('index',[
            'INIT'
        ]),
        ...mapActions('index',[
            'flush',
            'loadmore'
        ]),
        ...mapActions('history',[
            'flushHistory'
        ]),
        close(){
            this.files = []
            this.showPanel = false
        },
         // 文件被上传之前
        async fileBeforeUpload (up, file) {
            this.showPanel = true
            // 已经获取过 uploadUrl
            if (file.uploadUrl) {
                up.setOption('multipart_params', file.multipart_params)
                up.setOption('url', file.uploadUrl)
                return
            }

            
            // 暂停上传，先获取 uploadUrl
            up.stop()
            let gid,pid
            if (this.$route.name == 'team' || this.$route.name == 'teamFolder') {
                let {tid,fid} = this.$route.params
                gid = tid
                pid = fid
            }

            file.groupid = gid || this.uploadConf.groupid || this.dialogData.groupid || this.group
            file.parentid = pid || this.uploadConf.parentid || this.dialogData.parentid || this.parentid
            file.startTime = (new Date()).getTime()
            let {type} = this.uploadConf
            
            let params = {
                groupid: file.groupid,
                parentid: file.parentid,
                size: file.size,
                name: file.name,
                contenttype: file.type,
                successactionstatus: 201,
                store: 's3_obs_oss'
            }
            let result = await new Promise((resolve) => {
                fetchUploadFileUrl(params,(res)=>{
                    resolve(res)
                })
            })
            if (result.status !== 200) {
                this.$message.error(this.$t(result.data.result))
                this.triggerError(up,file,result)
                this.updateQueue(up)
                return
            }
            let store = result.data.store
            file.store = store
            if (store == 's3') {
                let {auth} = result.data
                file.uploadUrl = `https://${auth.upload_url}`
                file.multipart_params = {
                    key: auth.key,
                    acl: auth.acl,
                    policy: auth['x-amz-policy'],
                    success_action_status: '201',
                    'x-amz-algorithm': auth['x-amz-algorithm'],
                    'x-amz-credential': auth['x-amz-credential'],
                    'x-amz-date': auth['x-amz-date'],
                    'x-amz-signature': auth['x-amz-signature'],
                }
                if (file.type) {
                    file.multipart_params['Content-Type'] = file.type
                }
            }else if(store == 'obs'){
                let auth = result.data
                up.settings.send_file_name = false
                file.uploadUrl = `https://${auth.url}`
                file.multipart_params = {
                    key: auth.key,
                    policy: auth['policy'],
                    AccessKeyId: auth.AccessKeyId,
                    signature: auth.signature,
                    success_action_status: '201'
                }
            }else if(store == 'oss'){
                let auth = result.data
                file.uploadUrl = `https://${auth.url}`
                file.multipart_params = {
                    OSSAccessKeyId: auth.AccessKeyId,
                    Signature: auth.signature,
                    policy: auth.policy,
                    key: auth.key,
                    success_action_status: '201'
                }
            }

            up.start()
        },
        updateQueue(up){
            // 更新 Panel 的上传总数状态
            Object.keys(this.total).forEach(key => {
                this.total[key] = key == 'failed' ? up.total[key] + this.rmfiles.length : up.total[key] 
            })
            let files = []
            up.files.forEach(file => {
                files.push({
                    id: file.id,
                    size: file.size,
                    fname: file.name,

                    result: file.result,
                    message: file.message,
                    fileid: file.fileid,
                    groupid: file.groupid,
                    parentid: file.parentid,

                    percent: file.percent,
                    complete: !file.completeTimestamp ? (new Date).getTime() + 10 : file.completeTimestamp,
                    failed: file.failed || (file.status === plupload.FAILED),
                    uploading: (file.failed || file.completeTimestamp) ? false : file.status < 5
                })
            })

            this.files = files.concat(this.rmfiles).sort((n1, n2) => n1.complete - n2.complete)
        },
        triggerError (up, file, error) {
                let message, result

                if (typeof error === 'string') {
                    message = result = error
                } else if (error && error.data) {
                    message = error.data.msg || 'failed'
                    result = error.data.result || 'errInter'
                } else {
                    message = result = error.message
                }

                _dw.onEvent('drive_upload',{
                    type: 'failed',
                    result
                })

                up.trigger('Error', {
                    file,
                    message,
                    code: plupload.HTTP_ERROR
                })

                file.result = result
                file.message = message
                setTimeout(() => {
                    up.start()
                }, 200)
            },

        async FileUploaded (up, file, info){
            let etag = info.response.match(/<etag[^>]*>((?:(?!<\/etag>)[\s\S])*)<\/etag>/gi)[0].slice(6,-7).replace(/"/g,"")
            let object_key = info.response.match(/<key[^>]*>((?:(?!<\/key>)[\s\S])*)<\/key>/gi)[0].slice(5,-6)
            let data = {
                size: file.size,
                sha1: etag,
                i: null
            }
            let relativePath = file.relativePath.split('/')
            relativePath.pop()
            relativePath.shift()
            let fileData = {
                groupid: String(file.groupid),
                parentid: file.parentid,
                name: file.name,
                size: data.size,
                parent_path: relativePath,
                sha1: data.sha1,
                store: file.store,
                object_key
            }
            file.store == 's3' ? fileData.storeid = data.i : ''
            
            let result
            try {
                result = await new Promise((resolve) => {
                    saveFile(fileData,(data) => {
                        resolve(data)
                    })
                })
            } catch (error) {
            }
            if (result.status !== 200) {
                if (this.uploadConf.type == 'newver') {
                    _dw.onEvent('drive_fileaction_history_update',{
                        type: 'failed',
                        result: result.data.result
                    })
                }
                this.triggerError(up,file,result)
            }else{
                let {parentid,id,groupid} = result.data
                let {type} = this.uploadConf
                file.complete = true
                file.fileid = id
                file.parentid = parentid

                this.parentid == fileData.parentid && this.shouldFlush && (this.route == 'all' || this.route == 'teams') ? this.flush(fileData.parentid) : ''
                let time = (file.completeTimestamp - file.startTime)/1000
                let size = file.size/1024
                let speed = size/time
                
                _dw.onEvent('drive_upload',{
                    type: 'success',
                    size: size.toFixed(2),
                    speed: speed.toFixed(2),
                    time: time.toFixed(2)
                })

                type == 'newver' ? _dw.onEvent('drive_fileaction_history_update',{
                        type: 'success'
                    }) : ''
                if (type == 'newver' && this.auto) {
                    this.INIT({
                        auto: this.auto,
                        noinit: true
                    })
                    this.flushHistory({groupid})
				    this.loadmore({noinit: true})
                }else if(this.route == 'starred'){
                    this.$store.dispatch('starred/flush',{noinit:true})
                    this.$store.dispatch('events/flush',{noinit: true})
                }else if(this.route == 'latest'){
                    this.$store.dispatch('events/flush',{noinit: true})
                }else if(this.route == 'teams'){
                    this.$store.dispatch('events/flush',{noinit: true})
                    type == 'newver' ? this.flushHistory({groupid}) : ''
                } else if(type == 'newver' && this.route == 'preview'){
                    this.$store.dispatch('preview/flush',{fileid: this.$route.params.fileid,noinit: true})
                    this.$store.dispatch('close')
                }else if(type == 'newver'){
                    this.flushHistory({groupid})
                }
                
            }
            this.updateQueue(up)
            


        },
        cancelFile(file){
            this.uploader.stop();
            this.uploader.removeFile(file.id);
            file = {
                complete: (new Date()).getTime(),
                failed: true,
                fileid: 0,
                fname: file.fname,
                groupid: 0,
                id: file.id,
                message: 'cancel',
                parentid: 0,
                percent: file.percent,
                result: 'Upcancel',
                size: file.size,
                uploading: false
            }
            this.rmfiles.push(file)
            this.updateQueue(this.uploader)
            this.uploader.start()
        },
        FileFiltered(up,file){
            let { type,ext,groupid,parentid,fileid,fname} = this.uploadConf
            let filename = file.name
            let idx = filename.lastIndexOf('.')
            let extIsMatch
            if (type == 'newver') {
                extIsMatch = idx > -1 && filename.slice(idx+1) === ext
                file.name = fname
            }else{
                extIsMatch = true
            }
            if (!extIsMatch) {
                this.$message.error(this.$t('Unmatched'))
                up.removeFile(file.id || fileid);
                return false;
            }

            //不上传.文件
            if(file.name[0] == '.'){
                up.removeFile(file.id);
                return false;
            }
            //不上传空文件
            if(!file.size){
                file.size = 0;
                this.triggerError(up, file, 'Emptyfile');
                !this.showPanel ? this.showPanel = true : ''
                this.emptyfiles.push(file)
                this.updateQueue(up)
            }

        },
        filesAdded(up,files){
            up.start()
        },
        fileProgress(up){
            this.updateQueue(up)
        },
        filesComplete(up,file){
            
        }


    },

    mounted () {
        let wraper = this.$refs['uploader-box']
        let btn = this.$refs.btn
        this.uploader = new plupload.Uploader({
            runtimes : 'html5,flash',
            browse_button : btn, 
            drop_element: 'dropzone',
            container: wraper, 
            multipart_params: {},
            url : "/examples/upload",
            // filters : {
            //     max_file_size : '10mb',
            //     mime_types: [
            //         {title : "Image files", extensions : "jpg,gif,png"},
            //         {title : "Zip files", extensions : "zip"}
            //     ]
            // },
            flash_swf_url : '/plupload/js/Moxie.swf',
            silverlight_xap_url : '/plupload/js/Moxie.xap',
            preinit: {
                UploadFile: this.fileBeforeUpload.bind(this)
            },
        
            init: {
                filesAdded: this.filesAdded.bind(this),
                FileUploaded: this.FileUploaded.bind(this),
                UploadProgress: this.fileProgress.bind(this),
                FileFiltered: this.FileFiltered.bind(this)
            }
        });
        delete this.uploader.settings.filters.prevent_empty
        this.uploader.init();
    },
    watch:{
        isFolder(cur,prev){
            let dom = document.querySelector('.drive-uploader input[type=file]')
            if (cur !== prev) {
                if (cur) {
                    dom.setAttribute('webkitdirectory',true)
                    dom.setAttribute('directory',true)
                }else{
                    dom.removeAttribute('webkitdirectory')
                    dom.removeAttribute('directory')
                }   
            }
        }
    }
}
</script>

<style>
.drive-uploader {
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    position: fixed;
    z-index: 2000;
}
.upload-input{
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/uploader/index.vue